import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink, useParams } from 'react-router-dom';
// material
import {
    Stack,
    Button,
    Container,
    Typography,
    Avatar,
    TextField
  } from '@mui/material';

import {
    TableCell,
    TableFooter,
    TableRow,
    makeStyles
} from "@material-ui/core";  

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';  

import {api, reiniciarToken, consItemVendaFinalizada} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { fFormataDinheiro } from '../../utils/formatNumber';
import produtoPadrao from '../../images/produto_padrao.jpg';

export default function ItensVenda() {
 
  const {id} = useParams();  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);

  let sumValorVenda;

  const getVendas = async () => {
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consItemVendaFinalizada(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_item_venda: valores.id_item_venda, 
                                     codigo_produto: valores.codigo_produto,
                                     produto: valores.produto,
                                     qtde_venda: valores.qtde_venda,
                                     valor_venda: valores.valor_venda,
                                     valor_venda_formatado: fFormataDinheiro(valores.valor_venda),
                                     observacao: valores.observacao,
                                     url: valores.url
                                    }]);                   
      });
    };
  }

  useEffect(() => {
    getVendas();
  },[])  

  let columns;

  if (localStorage.getItem(['tipo_comercio']) === '6') {
    columns = [{name:"codigo_produto", label: "Código Produto"}
            ,{name: "",
              options: {
              filter: false,
              sort: false,
              empty: true,
              customBodyRenderLite: (dataIndex, rowIndex) =>  {
                return (
                  <> 
                    <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : produtoPadrao} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                  </> 
                );
              }}
            }
            ,{name:"produto", label: "Produto"}
            ,{name:"qtde_venda", label: "Qtde Venda"}
            ,{name:"valor_venda_formatado", label: "Valor Venda"}
            ,{name:"observacao", label: "Observação",
              options: {
              empty: true,
              customBodyRenderLite: (dataIndex, rowIndex) =>  {
                return (
                  <> 
                    <TextField
                      style= {{width: 300}} 
                      multiline='true'
                      rows={2}
                      rowsMax={4}
                      value={dados[dataIndex].observacao}
                    />
                  </> 
                );
            }}
            }
          ];
  }else{
    columns = [{name:"codigo_produto", label: "Código Produto"}
            ,{name: "",
              options: {
              filter: false,
              sort: false,
              empty: true,
              customBodyRenderLite: (dataIndex, rowIndex) =>  {
                return (
                  <> 
                    <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : produtoPadrao} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                  </> 
                );
              }}
            }
            ,{name:"produto", label: "Produto"}
            ,{name:"qtde_venda", label: "Qtde Venda"}
            ,{name:"valor_venda_formatado", label: "Valor Venda"}
          ];
  };

  const useStyles = makeStyles((theme) => ({
    footerCell: {
        backgroundColor: "#cccccc",
        borderBottom: "none",
        color: "black",
        fontSize: 14,
        fontWeight: 'bold'
    }
  }));

  const classes  = useStyles();

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
    selectToolbarPlacement: "none",
    customTableBodyFooterRender: (opts) => {
        
        sumValorVenda = dados
            .reduce((total, item) => {
            return (total +  item.valor_venda);
        }, 0);

        return (
            <>
            {dados.length > 0 && (
                <TableFooter className={classes.footerCell}>
                <TableRow>
                    {opts.selectableRows !== 'none' ? <TableCell className={classes.footerCell} /> : null}
                    {opts.columns.map((col, index) => {
                    if (col.display === "true") {
                        if (col.name === "qtde_venda") {
                        return (
                            <TableCell key={index} className={classes.footerCell}>
                            TOTAL
                            </TableCell>
                        );
                        }if (col.name === "valor_venda_formatado") {
                        return (
                            <TableCell key={index} className={classes.footerCell}>
                            {fFormataDinheiro(sumValorVenda)}
                            </TableCell>
                        );
                        }  
                        if (col.name !== "qtde_venda" && col.name !== "valor_venda_formatado") {
                        return <TableCell key={index} className={classes.footerCell}/>
                        };
                    }
                    return <TableCell key={index} className={classes.footerCell}/>;
                    })
                    }
                </TableRow>
                </TableFooter>
            )}
            </>
        );
    }
  };               
                    
  return (
    <Page title="Itens Venda">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
              Itens da Venda: Nº {id}
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained"  color="neutral" component={RouterLink} to="/venda/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <Stack mb={2} spacing={10}>
          <MUIDataTable
              data={Object.values(dados)}
              columns={columns}  
              options={options} 
          />
        </Stack>
      </Container>  
    </Page>  
  );
}

